import { AstroTransitionLink } from "@components/ui/AstroTransitionLink"
import OptimizedImage from "@components/ui/OptimizedImage"
import { useRoutePageContext } from "@components/ui/route-page-context"
import { imageAlt, imageRenderProps, imageTitle } from "@lib/component-utils"
import { sanitizeRichHtml } from "@lib/sanitize-html"
import { careersTransitionName } from "@lib/view-transitions"
import type { CareerItem } from "@site-types/content"
export function CareersCard({ position, priority = false }: { position: CareerItem; priority?: boolean }) {
  const { locale } = useRoutePageContext()
  if (!position.newsCoverImage) return null
  const transitionName = careersTransitionName(position.slug?.current ?? "")
  return (
    <li
      className="relative aspect-[1/1.6] list-none bg-[var(--position-bg-color)] [--clip-inset:20px] [clip-path:polygon(0%_0%,calc(100%-var(--clip-inset))_0%,100%_var(--clip-inset),100%_100%,var(--clip-inset)_100%,0%_calc(100%-var(--clip-inset)))] [container-type:inline-size]"
      data-content-transition-element="true"
      data-content-transition-name={transitionName}
      data-id={`career-card-${position.slug?.current ?? "unknown"}`}
    >
      <AstroTransitionLink
        to={`/${locale}/careers/${position.slug?.current}`}
        className="absolute z-[100] block h-full w-full"
        aria-label={position.title}
        data-id={`career-card-link-${position.slug?.current ?? "unknown"}`}
        transitionName={transitionName}
      />
      <OptimizedImage
        className="absolute z-[1] block h-full w-full object-cover object-top"
        title={imageTitle(position.newsCoverImage, locale)}
        alt={imageAlt(position.newsCoverImage, locale)}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={priority ? "high" : "auto"}
        {...imageRenderProps(position.newsCoverImage, "careerCard")}
      />
      <h4 className="absolute bottom-[12cqw] z-10 block w-full px-[1em] text-center text-[8cqw] leading-[1em]">
        {position.title}
      </h4>
      <h5
        className="absolute bottom-[5cqw] z-[11] block w-full px-[1em] text-center text-[5cqw] text-[var(--white-50)] leading-[1em]"
        dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(position.teamName) }}
      />
    </li>
  )
}

export default CareersCard
